import { observer } from 'mobx-react-lite';
import { useContent } from '@/stores/RootStore';
import { useReveal } from '@/hooks/useReveal';
import SectionHeader from '@/components/ui/SectionHeader';
import s from './Location.module.scss';

// 오시는 길 — 융합사이트(evstech 오시는길) 반영. 주요 거래처 아래, 기존 React 디자인 언어(SectionHeader+카드).
//   본사=정확한 구글맵 임베드, R&D센터=주소 기반 임베드(원본이 본사 지도 재사용 이슈라 대체).
const Location = observer(() => {
  const { location } = useContent();
  const reveal = useReveal<HTMLDivElement>();
  return (
    <section className={s.section}>
      <div className={s.inner} ref={reveal}>
        <SectionHeader title={location.title} tagline={location.tagline} divider className="anim-scroll" />
        <div className={s.grid}>
          {location.offices.map((o) => {
            const src = 'mapEmbed' in o && o.mapEmbed
              ? o.mapEmbed
              : `https://maps.google.com/maps?q=${encodeURIComponent((o as { mapQuery: string }).mapQuery)}&z=16&hl=ko&output=embed`;
            return (
              <div className={s.office} key={o.label}>
                <div className={s.map}>
                  <iframe src={src} title={`${o.label} 지도`} loading="lazy" allowFullScreen referrerPolicy="no-referrer-when-downgrade" />
                </div>
                <div className={s.info}>
                  <span className={s.label}>{o.label}</span>
                  <p className={s.addr}>{o.address}</p>
                  <p className={s.tel}>Tel. {o.tel}</p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
});

export default Location;
